import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const footerSelector = state => state.app.footer;

const isFooterCollapsed = createSelector(
  footerSelector,
  footer => footer.collapsed
);

export default isFooterCollapsed;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/isFooterCollapsed.js